import { render, staticRenderFns } from "./ChartPie.vue?vue&type=template&id=37ca2fe6&scoped=true"
import script from "./ChartPie.vue?vue&type=script&lang=js"
export * from "./ChartPie.vue?vue&type=script&lang=js"
import style0 from "./ChartPie.vue?vue&type=style&index=0&id=37ca2fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ca2fe6",
  null
  
)

export default component.exports